import React from 'react'
import SEO from '../components/SEO'

export default function CallUs(){
    const ContactCard = ({ title, children }) => (
        <div className="card mb-3 shadow-sm">
            <div className="card-body">
                <h3 className="h6 card-title">{title}</h3>
                {children}
            </div>
        </div>
    );

    const ContactRowItem = ({ label, href, children }) => (
        <p className="mb-2">
            <strong>{label}:</strong><br />
            {href ? <a href={href}>{children || href}</a> : children}
        </p>
    );

    return (
        <main className="container my-5" role="main">
            <SEO
                title="Call Us | 100Eyes Technologies LLP"
                description="Call or email 100Eyes Technologies. We're available Monday to Saturday to discuss enterprise software, web and mobile projects."
                canonical="https://100eyestechnologies.com/call-us"
            />

            <header className="mb-4">
                <h1 className="mb-2">Call Us — Contact & Support</h1>
                <p className="lead mb-0">
                    We're available Mon–Sat, 9:00 AM – 6:00 PM IST. For urgent support outside these hours, email us or call the emergency number (SLA customers).
                </p>
            </header>

            <div className="row g-4">
                <div className="col-lg-6">
                    <ContactCard title="Primary Contacts">
                        <ContactRowItem label="Sales & New Projects" href="tel:+917011158577">+91 70111 58577</ContactRowItem>
                        <ContactRowItem label="Support & Maintenance" href="tel:+9971335787">+91 99713 35487</ContactRowItem>
                        <ContactRowItem label="Email" href="mailto:info@100eyestechnologies.com">info@100eyestechnologies.com</ContactRowItem>
                        <ContactRowItem label="Emergency / Critical Incident" href="tel:+919971335487">+91 99713 35487 (SLA customers)</ContactRowItem>

                        <h4 className="h6 mt-3">Support channels</h4>
                        <ul className="mb-0">
                            <li>Phone & WhatsApp for quick queries</li>
                            <li>Email for non-urgent requests: <a href="mailto:info@100eyestechnologies.com">info@100eyestechnologies.com</a></li>
                            <li>Support portal for ticket tracking: <a href="/contact-us">support</a></li>
                            <li>Project inquiry & consultation: <a href="/contact-us">Contact form</a></li>
                        </ul>
                    </ContactCard>

                    <ContactCard title="Hours & response targets">
                        <ul className="mb-0">
                            <li>Business hours: Mon–Sat, 9:00 AM – 9:00 PM IST</li>
                            <li>Typical email response within 24 hours</li>
                            <li>Enterprise SLA customers: initial response within 4 hours for Priority 1 incidents</li>
                        </ul>
                    </ContactCard>

                    <ContactCard title="Preparing for a consultation">
                        <p className="mb-2">To help us evaluate your project quickly, please include:</p>
                        <ul className="mb-0">
                            <li>High-level goals and success criteria</li>
                            <li>Estimated timeline and budget range</li>
                            <li>Current systems or tech stack (if any)</li>
                            <li>Expected number of users and performance requirements</li>
                            <li>Any compliance or security constraints</li>
                        </ul>
                    </ContactCard>
                </div>

                <div className="col-lg-6">
                    <ContactCard title="Office">
                        <address className="mb-2">
                            100Eyes Technologies LLP<br />
                            Khasra no 392/2, J BLK, Gali no 1, Saroop Nagar<br />
                            New Delhi, Delhi, India
                        </address>

                        <p className="mb-2">
                            <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>
                        </p>

                        <div className="ratio ratio-16x9 mb-3" aria-hidden="true">
                            <iframe
                                title="Company location map"
                                src="https://www.google.com/maps?q=28.7602811,77.1493309&z=15&output=embed"
                                style={{ border: 0 }}
                                allowFullScreen
                            />
                        </div>

                        <p>
                            <strong>Prefer a consultation?</strong> Use our <a href="/contact-us">contact form</a> to share project details, preferred times, and an estimated budget. We’ll schedule a discovery call within 1–3 business days.
                        </p>
                    </ContactCard>

                    <ContactCard title="What to expect after you contact us">
                        <ol className="mb-0">
                            <li>We acknowledge your message within business hours.</li>
                            <li>Schedule a discovery call to clarify requirements.</li>
                            <li>Deliver a written proposal and estimate.</li>
                            <li>Agree on milestones, sign contract, and begin work.</li>
                        </ol>
                    </ContactCard>

                    <ContactCard title="Frequently asked questions">
                        <details>
                            <summary className="mb-2">Do you offer on-site visits?</summary>
                            <p className="mb-0">We primarily work remotely but can arrange on-site visits for enterprise engagements within India.</p>
                        </details>

                        <details className="mt-2">
                            <summary className="mb-2">Do you sign NDAs?</summary>
                            <p className="mb-0">Yes — we are happy to sign NDAs for confidential projects.</p>
                        </details>
                    </ContactCard>
                </div>
            </div>

            <footer className="mt-4">
                <p className="small text-muted mb-0">
                    We treat all project information as confidential. By contacting us you agree to our <a href="/privacy-policy">privacy policy</a>.
                </p>
            </footer>
        </main>
    );
}
